import React from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import SelectFormGroup from "assets/scripts/components/common/form/SelectFormGroup/SelectFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
const messages = defineMessages({
    authorizedIndividualLabel: {
        id: "forms.authIndividual.authorizedIndividual.label",
        defaultMessage: "Authorized individual"
    },
    authorizedIndividualNullOption: {
        id: "forms.authIndividual.authorizedIndividual.nullOption",
        defaultMessage: "Select Authorized Individual"
    }
});
export default function AuthorizedPersonInput(props) {
    const options = [
        {
            value: "",
            label: messages.authorizedIndividualNullOption
        },
        ...props.authIndividuals.map(({ id, firstName, lastName }) => ({
            value: id.toString(),
            label: `${firstName} ${lastName}`
        }))
    ];
    return (<fieldset className="fieldset">
			<legend>
				<span className="u-isVisuallyHidden">
					<FormattedMessage id="forms.authIndividual.legend" defaultMessage="Authorized Individual"/>
				</span>
			</legend>

			<SelectFormGroup name="authId" label={messages.authorizedIndividualLabel} value={props.authId == null ? "" : props.authId.toString()} onChange={(value) => {
        props.onChange(value === "" ? null : parseInt(value, 10));
    }} error={props.authId == null ? REQUIRED : null} required options={options}/>
		</fieldset>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/AuthorizedPersonInput/AuthorizedPersonInput.tsx